import { Link } from 'react-router-dom';

/** 404 — a specific, branded not-found state (never a blank page). */
export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-6 px-6 py-24 text-center">
      <p className="font-display text-5xl font-semibold tracking-[0.12em] text-accent">404</p>
      <h1 className="font-display text-2xl font-semibold uppercase tracking-[0.12em] text-ink">
        Page not found
      </h1>
      <p className="max-w-prose font-serif text-lg text-muted">
        That page doesn’t exist. It may have moved, or the link may be incomplete.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-md border border-border px-5 py-2.5 font-sans text-sm font-semibold text-ink transition-colors duration-150 ease-standard hover:bg-surface focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        Return home
      </Link>
    </div>
  );
}
